import TwigFormValidator from '../_00_elements/tools/twig-form/validator';
import { showSubmitLoader } from '../_01_atoms/spinner';
import { addCaptchaToForm } from '../_00_elements/recaptcha-helper';
import eventBus from '../_00_elements/tools/event-bus';
import {
  URL_SELLER_ONBOARDING_RESEND_EMAIL,
  URL_OFFER_CREATE,
} from '../_00_elements/tools/routes/routes';
import resendInitPasswordEmail from '../_00_elements/resend-init-password-email';
import initVuePhoneInput from '../_01_atoms/twig-phone-input';

const formSelector = 'seller-onboarding-form';

function initFormValidation() {
  const phoneInputApp = initVuePhoneInput('vue-phone-input');
  const validator = new TwigFormValidator({
    formSelector: `#${formSelector}`,
    rules: {
      'seller_onboarding_form[organization][name]': 'required',
      'seller_onboarding_form[fullName]': [ 'required', 'noNumbers' ],
      'seller_onboarding_form[email]': [ 'required', 'email' ],
      'seller_onboarding_form[phoneNumber]': 'phone',
    },
    messages: {
      'seller_onboarding_form[fullName]': [ 'required', 'noNumbers' ],
      'seller_onboarding_form[email]': [ 'required', 'email' ],
    },
    onFailure: (event, messages) => {
      const phoneError = messages['seller_onboarding_form[phoneNumber]'];
      phoneInputApp.error = phoneError ?? null;
      event.stopImmediatePropagation();
    },
    onSuccess: (event) => {
      phoneInputApp.error = null;
      showSubmitLoader(event.target.querySelector('button[type=submit]'));
    },
  });
  validator.init();
}

function attachEventListenerLoginLinks() {
  document
    .querySelectorAll('#seller-onboarding .seller-onboarding-login')
    .forEach((element) => {
      element.addEventListener('click', () => {
        eventBus.dispatchEvent(new CustomEvent('show-login-modal', {
          detail: {
            email: null,
            redirectUrl: URL_OFFER_CREATE,
          },
        }));
      });
    });
}

export default function () {
  initFormValidation();
  attachEventListenerLoginLinks();
  resendInitPasswordEmail('#seller-onboarding .seller-onboarding-email-resend', URL_SELLER_ONBOARDING_RESEND_EMAIL);
}

window.addEventListener('load', () => {
  addCaptchaToForm(formSelector, 'seller_onboarding_form');
});
